import Improvement from './Improvement';
import './Improvement.scss';

export default Improvement;